import React, { useState } from 'react'
import Photo from '../Photo/Photo'
import styles from "./profile.module.css"
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import { updatePost } from '../../utils/Fetch/fetch'
import { toast } from 'react-toastify'
const Profile = () => {
    const [inputs, setInputs] = useState({
      name:"",
      occupation:"",
      email:"",
      number:"",
      location:"",
      github:"",
      linkedin:"",
    })

    const [imageurl, setImageurl] = useState("pic.jpg")
    const [color, setColor] = useState(false)
    const [show, setShow] = useState(false)

    const handleChange = (e) => {
      let {value, name} = e.target;
      setInputs({
        ...inputs,
        [name] : value
      })
    }

    const handleShowInputs = () => {
      setShow(!show)
    }

    const handleSave = async () => {
      let { name, occupation, email, number, location, github, linkedin } = inputs;
      if(name==="" || occupation==="" || email==="" || number==="" || location==="" || github==="" || linkedin===""){
        toast("Please fill all the data");
        setColor(false);
        return;
      }
      const updatedata = async () => {
        let data = await updatePost(JSON.stringify({image:imageurl, name, occupation, email, mobile:number, location, github, linkedin }))
        return data;
      }
      let updatedData = await updatedata()
      if(updatedData.success===true){
        toast("Profile data is saved successfully!")
        setColor(true)
        setShow(false)
      }else {
        toast("Something went wrong!")
      }
    }

  return (
    <div className={styles.profile__container}>
        <nav className={styles.profile__nav} onClick={handleShowInputs}>
        <h3 style={{color : color===false ? "crimson" : 'grey'}}>Profile Details</h3>
        <span>
          {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
        </span>
        </nav>
        {
          show &&  <div className={styles.profile__box}>
          <div className={styles.profile__input}>
            <div>
            <Photo imageurl={imageurl} setImageurl={setImageurl}/>
            </div>
            <br />
            <input type="text" placeholder='Enter your name' name='name' onChange={e => handleChange(e)}/>
            <input type="text" placeholder='Enter your occupation' name='occupation'onChange={e => handleChange(e)}/>
            <input type="email" placeholder='Enter your email' name='email'onChange={e => handleChange(e)}/>
            <input type="number" placeholder='Enter mobile number' name='number' onChange={e => handleChange(e)}/>
            <input type="text" placeholder='Enter your location' name='location'onChange={e => handleChange(e)}/>
            <input type="text" placeholder='Enter your github username' name='github'onChange={e => handleChange(e)}/>
            <input type="text" placeholder='Enter your linkedin username' name='linkedin' onChange={e => handleChange(e)}/>
          </div>
          <div className={styles.savebtn_box}>
          <button className={styles.savebtn} onClick={handleSave}>Save</button>
          </div>
        </div>
        }
       
    </div>
  )
}

export default Profile